import { useQuery } from '@tanstack/react-query';
import { getDashboardStats } from '../../infrastructure/api/dashboardApi';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E20 — GET /dashboard/stats (role-scoped nulls for L1/L2). */
export function useDashboardStats() {
  return useQuery({ queryKey: qKeys.dashboard, queryFn: getDashboardStats, ...queryDefaults });
}
